import React, { FC } from 'react';

import { Dropdown } from 'antd';

// Shared UI Library Components
import { CustomIcon, EIconName, Loader } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './session-item.scss';

// Models
import { IStoreSession } from '../../../../interfaces/session-settings.interfaces';
import { TSessionType } from '../../../../types/settings.types';

type TSessionItemProps = {
  session: IStoreSession;
  onDelete?: (session: IStoreSession) => void,
  onEdit?: (session: IStoreSession, type: TSessionType) => void,
  loading?: boolean,
};

export const SessionItem: FC<TSessionItemProps> = (
  {
    session,
    onDelete = () => {},
    onEdit = () => {},
    loading = false
  }: TSessionItemProps
) => {
  const menuItems = [
    {
      key: 'edit',
      label: (
        <div className="actions-item">
          <CustomIcon name={ EIconName.Edit } size={'size-lg'}/>
          Edit
        </div>),
      onClick: () => onEdit(session, session.session_type)
    },
    {
      key: 'delete',
      label: (
        <div className="actions-item">
          <CustomIcon name={ EIconName.Delete } size={'size-lg'}/>
          Delete
        </div>),
      onClick: () => onDelete(session)
    },
  ];

  return (
    <div className="session-item">
      <div className="session-item--item item-duration">
        <div className="item-title">
          Duration
        </div>
        <div className="item-value">
          <span className="text-bold">{ session.call_duration }</span> min
        </div>
      </div>
      {/*<div className="session-item--item item-buffer-time">*/}
      {/*  <div className="item-title">*/}
      {/*    Buffer Time*/}
      {/*  </div>*/}
      {/*  <div className="item-value">*/}
      {/*    <span className="text-bold">{ session.call_buffer }</span> min*/}
      {/*  </div>*/}
      {/*</div>*/}
      <div className="session-item--item item-actions">
        { loading ? <Loader/> :
          <Dropdown menu={ { items: menuItems } } trigger={ ['click'] } placement="bottomLeft" arrow>
            <CustomIcon name={ EIconName.BurgerMenu }/>
          </Dropdown> }
      </div>
    </div>
  );
}
